import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { formatDateSlash, getToken, setPodcastSession } from "../../utils";
import { getFullApiUrl, podcastId } from "../../config";
import { Button, Icon } from "../../designSystem";
import Notice from "../ui/Notice";
import { LoadingPage } from "../LoadingPage";

const SubscriptionSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setError("缺少会话ID");
      setLoading(false);
      return;
    }

    // Check user's subscription status
    checkSubscriptionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const checkSubscriptionStatus = async () => {
    try {
      const token = getToken();
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await axios.get(
        getFullApiUrl("/api/v1/stripe/user-subscriptions"),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (
        response.data.subscriptions &&
        response.data.subscriptions.length > 0
      ) {
        setSubscriptionInfo(response.data.subscriptions[0]);

        // After confirming subscription, get user info including podcast session
        await fetchUserInfo();
      }
    } catch (err) {
      console.error("Failed to check subscription status:", err);
      setError("无法确认订阅状态，请联系客服");
    } finally {
      setLoading(false);
    }
  };

  const fetchUserInfo = async () => {
    try {
      const token = getToken();
      if (!token) return;

      const response = await axios.get(
        getFullApiUrl(`/api/v1/auth/user-info?podcast_id=${podcastId}`),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.podcast_session) {
        setPodcastSession(response.data.podcast_session);
      }
    } catch (err) {
      console.error("Failed to fetch user info:", err);
      // Don't show error to user as this is optional
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="lt-main">
      <div className="lt-result">
        <span className="lt-result__glyph lt-result__glyph--success">
          <Icon name="check_circle" fill style={{ verticalAlign: 0 }} />
        </span>
        <h1>订阅成功，欢迎加入</h1>
        <p className="desc">感谢您的订阅，现在可以收听所有付费内容了。</p>

        {error ? (
          <Notice variant="warning" style={{ marginTop: 16, textAlign: "left" }}>
            {error}
          </Notice>
        ) : null}

        {subscriptionInfo ? (
          <Notice variant="success" style={{ marginTop: 16, textAlign: "left" }}>
            订阅状态：
            {subscriptionInfo.status === "active" ? "有效" : subscriptionInfo.status}
            · 当前周期到 {formatDateSlash(subscriptionInfo.current_period_end)}
            {subscriptionInfo.cancel_at_period_end ? "（将在周期结束后取消）" : ""}
          </Notice>
        ) : null}

        <div className="actions">
          <Button size="lg" icon="play_arrow" onClick={() => navigate("/")}>
            开始收听
          </Button>
          <Button size="lg" variant="secondary" onClick={() => navigate("/subscription/manage")}>
            管理订阅
          </Button>
        </div>

        <p className="foot">如有任何问题，请联系客服微信：lalambdada</p>
      </div>
    </div>
  );
};

export default SubscriptionSuccessPage;
